import { createSelector } from "reselect";
import { assessmentVersionSelector } from "src/selectors/config_selectors";

export const hprScoreEnabledSelector = createSelector(
  assessmentVersionSelector,
  version => version == "ML1"
);
